import { useMutation } from "@apollo/client";

import { UpdateBeneficiaryMutation, UpdateBeneficiaryMutationVariables } from "@ctypes";
import { UPDATE_BENEFICIARY, USER } from "@graphql";

export const useUpdateBeneficiary = () => {
  return useMutation<UpdateBeneficiaryMutation, UpdateBeneficiaryMutationVariables>(
    UPDATE_BENEFICIARY,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
